import * as React from "react";
import NoOptionsIllo from "./NoOptionsIllo";

import FilterContext from "./context/Filter";
import OptionForm from "./OptionForm";

const NoOptions = () => {
  const ctx = React.useContext(FilterContext);

  return (
    <div className="vm-flex vm-items-center vm-flex-col vm-justify-center">
      <NoOptionsIllo width="400" height="250" />
      <h2 className="vm-text-2xl vm-text-gray-700 vm-font-semibold vm-mb-1">
        Add {ctx.state.title}
      </h2>
      <p className="vm-text-lg vm-text-gray-600 vm-mb-4">
        Define choices your viewers can find videos by within a filter.
      </p>
      <OptionForm />
    </div>
  );
};

export default NoOptions;
